
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17 3.75a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v16.5a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V3.75zm-.5-2.5a2.5 2.5 0 012.5 2.5v16.5a2.5 2.5 0 01-2.5 2.5h-9a2.5 2.5 0 01-2.5-2.5V3.75a2.5 2.5 0 012.5-2.5h9z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 5.25a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1z","fill":"#282E3E"}}),_c('path',{attrs:{"d":"M13.241 18.112a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z","fill":"#282E3E"}})])
          )
        }
      }
    